import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import React from "react";

const plochy = [
  ["Zastavěné a těžce propustné plochy", "plochaZast"],
  ["Vegetační střechy s mocností 5–10 cm", "plochaVegSt1"],
  ["Lehce propustné plochy", "plochaProp"],
  ["Vegetační střechy s mocností 11–30 cm", "plochaVegSt2"],
  ["Vegetační střechy s mocností 31 cm a více", "plochaVegSt3"],
  ["Plochy s vegetací", "plochaVeg"],
];

export default function SrazkovaVoda({ selectedCollectionPoint }) {
  const srazkovaVoda = selectedCollectionPoint.srazkovaVoda || [];

  return (
    <>
      {srazkovaVoda.length > 0 ? (
        <Box sx={{ mt: 4 }}>
          {srazkovaVoda.map((zaznam, index) => (
            <Box key={zaznam.id} sx={{ mb: 3 }}>
              {srazkovaVoda.length > 1 && (
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  Srážková voda {index + 1}
                </Typography>
              )}
              <TableContainer component={Paper}>
                <Table size="small" aria-label="Plochy srážkové vody">
                  <TableHead>
                    <TableRow>
                      <TableCell>Plocha</TableCell>
                      <TableCell align="right">Plocha m²</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {plochy.map(([nazev, pole]) => (
                      <TableRow key={pole}>
                        <TableCell>{nazev}</TableCell>
                        <TableCell align="right">{zaznam[pole] || 0}</TableCell>
                      </TableRow>
                    ))}
                    <TableRow>
                      <TableCell sx={{ fontWeight: 700 }}>Celková vypočtená plocha</TableCell>
                      <TableCell align="right" sx={{ fontWeight: 700 }}>
                        {zaznam.plochaCelk || 0}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          ))}
        </Box>
      ) : (
        <Typography variant="body2" sx={{ mt: 2 }}>
          Nebyly nalezeny žádné záznamy.
        </Typography>
      )}
    </>
  );
}
